// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"195":"5aa43bba","489":"fa9b7887"}[chunkId] + ".chunk.js";
};